import { Children } from 'react';
import { Accordion, SkeletonPlaceholder } from '@carbon/react';

import styles from 'theme/features/outputs/components/outputs-accordion.module.scss';

const OutputsAccordion = ({ children, isLoading }) =>
  isLoading ? (
    <div className={styles.accordion}>
      {Children.map(children, (_, i) => (
        <SkeletonPlaceholder key={i} className={styles.skeleton} />
      ))}
    </div>
  ) : (
    <Accordion className={styles.accordion}>{children}</Accordion>
  );

export default OutputsAccordion;
